package com.pincer.app

import com.pincer.core.model.drafts.ParticipantDraft
import com.pincer.core.model.drafts.QuestionDraft
import kotlin.time.Clock

/*
Just those bits of application state that we throw away on restart
*/
class TransientState() {

    // TODO location and pid are currently the same value ... we always fill one from the other and don't keep track
    // of any deeper locaiton like #PIDPIDPIDPID/candidate/1234 or similar. Drop the duplication until we do at least?

    var location: String?                   = null
    var pid: String?                        = null
    var expectingCode: Boolean              = false
    var claimedCredential: String?          = null
    var credentialCode: String?             = null
    var credentialCodeMayBeWrong: Boolean   = false
    var arrivedAnonymous: Boolean           = false
    var newPincerName: String?              = null
    var draftChat: String?                  = null
    var unexpectedError: Throwable?         = null
    var newQuestion                         = QuestionDraft()
    var lockedPrincipalUntil: Long?         = null
    // Nodes people have opened or closed (Node.open), by compound key; the rest are as the view model starts them
    val opened                              = mutableMapOf<String, Boolean>()
    fun lockedPrincipalRemainingSeconds() = lockedPrincipalUntil!! - (Clock.System.now().toEpochMilliseconds() / 1000).toInt()
    fun lockedPrincipalRemainingMinutes() = kotlin.math.max(2, (lockedPrincipalRemainingSeconds() / 60).toInt())
    fun lockedPrincipal() = lockedPrincipalUntil != null && lockedPrincipalRemainingSeconds() > 0

}
